module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('table', {
    staticClass: "chapter-title-corner-decorations",
    attrs: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "chapter-title-corner-decoration-left-column"
  }, [_c('div', {
    staticClass: "chapter-title-corner-decoration-left-column"
  }, [_c('img', {
    staticClass: "chapter-title-corner-decoration-left",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_corner_decoration_left.png"
    }
  })])]), _c('td', {
    staticClass: "chapter-title-corner-decoration-middle-column"
  }), _c('td', {
    staticClass: "chapter-title-corner-decoration-right-column"
  }, [_c('div', {
    staticClass: "chapter-title-corner-decoration-right-column"
  }, [_c('img', {
    staticClass: "chapter-title-corner-decoration-right",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_corner_decoration_right.png"
    }
  })])])])])]), _c('div', {
    staticClass: "chapter-title"
  }, [_c('div', {
    staticClass: "chapter-title-decoration-above"
  }, [_c('div', {
    staticClass: "chapter-title-decoration-above-inner"
  }, [_c('img', {
    staticClass: "chapter-title-decoration-above",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_above.png"
    }
  })])]), _c('h1', {
    staticClass: "chapter-title"
  }, [_vm._v("A Pezzi")]), _vm._v(" "), _c('h1', [_vm._v("Parte Ottava")]), _vm._v(" "), _c('h1', [_vm._v("SKY CORGAN")]), _vm._v(" "), _c('div', {
    staticClass: "chapter-title-decoration-below"
  }, [_c('div', {
    staticClass: "chapter-title-decoration-below-inner"
  }, [_c('img', {
    staticClass: "chapter-title-decoration-below",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_below.png"
    }
  })])])]), _c('p', {
    staticStyle: {
      "page-break-before": "always",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Copyright 2016 di Sky Corgan")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Tutti i diritti riservati.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Nessuna parte di questa pubblicazione può essere riprodotta, venduta o trasmessa in nessuna forma e con nessun mezzo, elettronico, meccanico, di fotocopiatura, di registrazione o in altro modo senza il permesso scritto dell’autore.")]), _vm._v(" "), _c('p', {
    staticClass: "section-break"
  }, [_vm._v("––––––––")]), _c('div', {
    staticClass: "decoration-scene-break"
  }, [_c('div', {
    staticClass: "decoration-scene-break-inner"
  }, [_c('img', {
    staticClass: "decoration-scene-break",
    attrs: {
      "alt": "image",
      "src": "d2d_images/scene_break.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "page-break-before": "always",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("CAPITOLO 1")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("PIPER")]), _vm._v(" "), _c('p', {
    staticClass: "first-in-scene",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('span', {
    staticClass: "first-scene-phrase"
  }, [_c('span', {
    staticClass: "first-in-scene character-s"
  }, [_vm._v("S")]), _vm._v("pray al pepe. Preso")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Coltellino tascabile. Preso. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Vestito che farà sospirare Holden per tutta la cena. Preso. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Ora, tutto ciò che devo fare è sperare di non essermi sopravvalutata. Ci sono un milione di cose che potrebbero andar storte stanotte. Non appena ho chiuso la porta di fronte a Holden, mi sono resa conto di quanto sia stato folle accettare di andare a cena con lui. Potrebbe essere una trappola. Il buonsenso mi dice che non dovrei andare. In passato ho praticamente preso a calci in culo Holden a l'ho umiliato al massimo. Vorrà vendetta. I ragazzi come lui lo fanno sempre. Il ricordo di Holden che si inginocchia davanti a me con tanta rabbia negli occhi è ancorato nella mia mente. A quel tempo, pensavo fosse sexy. Aveva uno sguardo pericoloso, comunque. Lui è pericoloso. Devo ricordarlo. La momentanea presa di potere che ho vissuto quando avevo il controllo della situazione mi ha impedito di pensare altrimenti. C'è una possibilità reale che Holden non abbia intenzione di portarmi fuori a cena - che io possa entrare in quella limousine e lui possa portarmi dai suoi scagnozzi per completare il lavoro. Non è un rischio che valga la pena di prendere. Ma non ho modo più breve di contattarlo e dirgli che ho cambiato idea se non chiamando Ann per avere il suo numero.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Anche se Holden ha detto che vuole che torni a lavorare per lei – anche se ha praticamente implorato perché ciò accada – io ancora non mi sento del tutto a mio agio con l’idea di tornare a parlarle. Questi uomini sono piuttosto inflessibili riguardo alle condizioni della mia sopravvivenza. Potrebbero ancora starmi osservando – avere il mio telefono sotto controllo o trovare un altro modo per scoprire se le ho parlato. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Mi sento di nuovo intrappolata e impotente. Questa volta, sono al sicuro nella mia casa, però. Non sono costretta a uscire quando arriverà la limousine. Potrei semplicemente ignorarla. Questa sarebbe una cosa intelligente da fare.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Tuttavia, respingere Holden potrebbe seccarlo. È molto facile seccarlo. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("L’intera situazione è complicata e confusa. Mi sento come se niente debba andare per il verso giusto. E a peggiorare il tutto, Earl si è gettato da sé nel pasticcio. Se non vado, e Holden finisce per arrabbiarsi e decide di passare all’azione, anche Earl sarà in pericolo?")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Mi siedo sul mio letto e sospiro, ben sapendo che devo andare. Se anche fosse una trappola, sento che devo caderci dentro per il bene di Earl. Se io dovessi morire, i ragazzi non avrebbero nessuno. Sarebbero dati in affidamento. Ma se Holden davvero volesse vendetta e io non dovessi andare, chissà che che cosa potrebbe fare a Earl. È meglio che sia io a pagare il fio per entrambi. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Un ghigno secco mi attraversa le labbra. Non molto tempo fa, non mi sarei preoccupata di Earl nemmeno se fosse stato gettato nel fuoco. Ora, amo quella piccola merda – sarei persino disposta a morire per lui se questo bastasse a tenerlo al sicuro. Forse è questo il potere della famiglia. Un legame forte che mi è mancato per tutta la mia vita fino a ora. Tuttavia, di certo questo complica le cose. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Per passare il tempo, vado in bagno a sistemare capelli e makeup, assicurandomi siano perfetti. Se devo morire stanotte, voglio almeno lasciarmi indietro un cadavere meraviglioso. È una cosa morbosa da pensare.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Cinque minuti prima delle otto, vado nel soggiorno. Earl e Joe sono seduti sul divano a guardare la televisione. Entrambi si voltano a guardarmi, e Joe sorride.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Sei carina”, cinguetta, le guance che sembrano così morbide che mi vien voglia di pizzicarle.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Grazie”. Gli sorrido di rimando benché sia un sorriso forzato, visti i pensieri riguardo alla potenziale situazione mortale che mi si prospetta.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Dove vai così agghindata?” mi chiede Earl. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Fuori”. Cerco di essere il più vaga possibile.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Sei sicura che sia una buona idea?”. Inarca un sopracciglio verso di me.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“C’è qualcosa che non va?”. Joe ci guarda.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Non c’è niente che non va”. Mi avvicino allo schienale del divano e gli stringo una spalla. Allora sospiro, tornando a rivolgere la mia attenzione a Earl. “Se non torno per mezzanotte, chiama la polizia”.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Earl si gira per guardarmi in faccia. “Dovresti scrivere tutto ciò che sai di quel ragazzo in modo che io abbia qualcosa da dare alla polizia, soprattutto dal momento che non mi hai raccontato poi molto”.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“È una buona idea” annuisco, forzandomi ad andare in cucina.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Che cosa sta succedendo?”. La voce di Joe è carica di preoccupazione.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Non preoccuparti”, Earl gli abbaia praticamente addosso, seccato. “È roba da adulti”.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Mentre mi allontano, sorrido del modo con cui ha detto “roba da adulti”. Ha solo quindici anni. Difficilmente definibile adulto.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Raggiungo la cucina e inizio a buttar già tutto ciò che posso riguardo a Holden su un bloc-notes, partendo dal numero di cellulare di Ann. Sfortunatamente, manca ancora molto quando suona il campanello. Abbastanza da dare a Earl le informazioni necessarie per esplodere. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Inspiro profondamente e cerco di mantenermi in equilibrio mentre cammino verso la porta d’ingresso e la apro. Mi aspetto di vedere Holden in piedi dall’altra parte, invece c’è un uomo in uniforme da autista. È basso e grasso, dal viso largo e bianchi capelli che sbucano dai lati del suo cappello in ciuffi.  ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Miss Gravatt, il mio nome è Barnaby. Sono l’autista del signor Longworth. Mi ha mandato a prenderla. È pronta per andare?”. Mi sorride cordialmente, del tutto amichevole e per nulla minaccioso. Stranamente, ciò mi porta a fidarmi ancor meno. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Guardo alle sue spalle verso la limousine. “Dov’è Holden?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“È rimasto indietro, miss”.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“È rimasto indietro” ripeto come un pappagallo. “Perché non è qui?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Aveva alcune cose da preparare”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Risposta sbagliata. Niente potrebbe suonare più sospetto.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Raccolgo tutto il mio coraggio e guardo Barbaby con freddezza. Anche se lui non ha un ruolo nella mia disputa con Holden, non posso fare a meno di trattarlo come un accessorio del nostro casino. “Potrebbe riferire a mr Longworth che ho cambiato idea e che ho deciso di non cenare con lui? Avrei voluto chiamare in anticipo e risparmiarle la fatica di venire fin qui, ma non ho il suo numero di telefono”.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Il sorriso di Barnaby si dissolve, e lui sembra assorto per un momento. “Mister Longworth non ne sarà felice”.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Davvero non me ne frega un cazzo”.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Non intendevo questo”. Solleva le mani come fosse preoccupato di avermi offesa. “Mi ha semplicemente ordinato di accertarmi che lei venga. Mi ha detto che voi due avete avuto un alterco e che lei probabilmente avrebbe detto di no nel momento in cui fossi passato a prenderla”.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Beh, aveva ragione”. Incrocio le braccia al petto.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Barnaby sospira. “Mister Longworth ha detto che mi avrebbe licenziato se non fossi riuscito a farla venire”.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Vorrei sentirmi dispiaciuta per lui, ma non ci riesco. “Probabilmente staresti meglio con un altro capo. Quel ragazzo è un cazzone completo”.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“È un tipo difficile, certe volte, ma non è privo di meriti. Penso che capisca che è difficile lavorare con lui, per questo paga più di chiunque altro in zona. È anche generoso quando si tratta di bonus e vacanze e quando ho bisogno di tempo per me. A essere onesti, anche se a volte è una vera fatica lavorare per lui, non potrei trovare lavoro migliore altrove. Ecco perché è così importante per me”.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Sposto il mio peso sull’altro piede e sospiro. “Mi dispiace, ma semplicemente non posso. Holden ha detto che saremmo andati fuori a cena insieme, e il fatto che non sia qui mi mette a disagio, specialmente considerando la nostra storia. Mi dispiace che tu probabilmente perderai il tuo lavoro per questo, ma io ho da perdere molto più di questo”.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Barnaby si irrigidisce per un momento prima di tirar fuori qualcosa dalla tasca. Prende un cellulare e preme un pulsante per digitare un numero prima di portarlo all’orecchio.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Rimanere in piedi qui mentre lui fa la chiamata è strano, benché sappia che sta contattando Holden. Una parte di me vuole rientrare e smettere di perdere tempo, ma sarebbe da maleducati sbattergli semplicemente la porta in faccia. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Holden lo merita, ma Barnaby no, specialmente se sta per perdere il lavoro per questo. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Mister Longworth, mi spiace disturbarla ma sono qui con miss Gravatt e lei si rifiuta di venire con me. Forse lei vorrebbe parlarle”. Mi porge il cellulare prima ancora che Holden abbia la possibilità di rispondere. C’è determinazione nei suoi grandi occhi blu. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Rimango a bocca aperta e lo guardo con stupore mentre lui prende la mia mano e mi forza ad afferrare il telefono. Quando mi lascia, non ho altra possibilità che afferrare il telefono prima che cada. L’istinto me lo fa afferrare. È un cellulare costoso, e non ho la più pallida idea se sia suo e sia un accessorio di lavoro dato da Holden. In ogni caso, mi sentirei in colpa se si rompesse.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Guardo Barnaby mentre mi porto il telefono all’orecchio. “Pronto”.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“So che non vuoi vedermi, ma ho progettato qualcosa di speciale per te”. Holden è serissimo.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Ruoto sui miei tacchi e abbasso la voce in un sussurro, cercando di mantenere privata la nostra conversazione. “Qualcosa di speciale, eh?” sbuffo. “Come un altro rapimento”.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Lui sospira. “Ero piuttosto preoccupato del fatto che, non presentandomi, avresti pensato questo”.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“L’avrei pensato anche se ti fossi presentato. La risposta è no. Non voglio cenare con te”.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Stai mettendo su una questione per nulla. Ti prometto che tutto ciò che ho programmato è assolutamente innocente”.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Tutto? Cosa è successo al "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("si tratta semplicemente di una cena")]), _vm._v("?”. Sposto il mio peso sull’altro piede. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“È solo una cena. Ma è una cena speciale”.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Se è solo una cena, perché non sei passato a prendermi?”. Mi rifiuto di credere alle sue cazzate. Sta succedendo qualcosa. Qualcosa di sinistro e oscuro. So che ha ancora qualcosa in sospeso con me, probabilmente ora più che mai. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Perché volevo che tutto fosse pronto quando tu fossi arrivata qui”.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Quando io fossi arrivata lì?”. Giro la testa di scatto. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Lui sbuffa. “Sei brava a rovinare le sorprese, eh?”.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Quando le sorprese non possono che finire con la mia morte definitiva, non mi interessa poi molto di rovinarle”. Il sarcasmo nel mio tono non potrebbe essere più sottile nemmeno se lo volessi.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Ti sto preparando la cena. A casa mia”, stacca ogni parola con chiarezza, come se non capissi l’inglese.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Perché? Non è ciò che avevamo stabilito”.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Non cucino per chiunque, Piper. Ecco perché dovrebbe essere speciale. Allo stesso modo non porto estranei in casa mia. E non puoi parlare di cambiamenti di piani considerando che hai deciso di cancellare l’appuntamento”.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Sembra sincero. Ma come faccio a fidarmi di lui?")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Con qualche esitazione, apro la bocca per replicare. “Senza offesa, ma suona come una scusa per avvelenarmi”.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Ugh, sei così difficile”, sbotta ma subito riconquista la sua compostezza. “Bene. Non sei obbligata a mangiare. Io mangerò. Solo. Tu puoi farti accompagnare da Barnaby a un takeaway o da qualche altra parte sulla strada”.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Un takeaway, eh?”. Poggio una mano sull’anca, divertendomi alquanto nel farlo disperare. “Cosa ne è stato della mia cena costosa? Anche il takeaway non era parte dell’accordo”.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Puoi ordinare tutto ciò che vuoi. In qualunque ristorante. Semplicemente chiedi a Barnaby di fare una chiamata e lui ti porterà direttamente lì. Solo, voglio che tu venga qui in fretta. Puoi anche non essere affamata, ma lo sono io”, dice senza troppi giri di parole. Posso affermare che gli ho fatto rapidamente perdere la pazienza.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Il ghigno che stavo sfoggiando si ammorbidisce. “Come posso sapere che non si tratta di una trappola?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Non puoi. Devi solo fidarti di me. Sia che tu venga sia che tu non lo faccia. Comunque, mi piacerebbe davvero che tu venissi. Penso che se solo ci concedessimo il tempo di sederci e avere una conversazione civile, questo spegnerebbe molta della tensione che c’è tra di noi. Potrebbe non essere poi così importante per noi, ma renderebbe le cose meno stressanti per mia madre visto che dovremmo interagire di nuovo con lei insieme”.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Oh, ma io non ho niente che non sia civile. Sei tu che sei stato una insopportabile testa di cazzo”. Rido amaramente. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Stai venendo o no?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Mi volto verso Barnaby, che ha un’espressione speranzosa sul viso. “Hai veramente intenzione di licenziare il tuo autista di limousine se non vengo?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Ti ha detto questo?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Sì, l’ha detto”. Faccio un sorriso forzato, anche se Holden non può vederlo.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("La linea è muta per qualche secondo. “No. Non lo licenzierò. Gli ho solo detto che avrebbe dovuto tentare il tutto per tutto per portarti qui”.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Forse Holden non è completamente senza cuore, dopotutto. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Do un’occhiata alla limousine attraverso il cortile. Il tempo sta passando e io ancora non riesco a prendere una decisione. C’è una buona possibilità che tutto ciò che mi ha detto fino a questo momento sia una bugia e che la sua storia sia solo una balla inventata per farmi entrare nella limousine, così che Barnaby potesse portarmi indietro nello spaventoso magazzino con i teppisti. Guardando Barnaby, tuttavia, non ho l’impressione che sia il tipo di persona che potrebbe prendere parte a qualcosa di oscuro come questo. Ma comunque, che cosa posso davvero sapere? Le persone spesso non sono ciò che sembrano.  ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Allora la mia mente torna a Earl. Sarebbe meglio per lui se io andassi. D’altra parte, noi già abbiamo inviato un piano di sicurezza. Se non sarò ritornata entro mezzanotte, lui chiamerà la polizia. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("La rigidità del mio corpo si allenta un po’, e lascio riposare il telefono contro il mio orecchio mentre continuo a fissare Barnaby. Il suo lavoro non è più in pericolo, anche se lui pensa che lo sia. Ancora però mi sembra ci siano molte responsabilità nella mia risposta. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Verrò”. Riattacco prima ancora che Holden abbia una possibilità di rispondere. Una parte di me non è contenta che io abbia accettato, ma è troppo tardi per tornare indietro, adesso. O non lo è? Non sono ancora nella limousine. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Sono felice che abbia accettato di venire, signora”. Mi si rivolge Barnaby. “Andiamo?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Presumo di sì”. Sospiro profondamente e gli permetto di accompagnarmi alla limousine, mentre lancio un ultimo, avvolgente sguardo prima di entrare.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Ogni cosa è elegante quanto uno si aspetterebbe da un uomo che guida una Ferrari. Sono già stata in una limousine, ma si trattava di una di quelle economiche prese in fitto. Questa qui è di design, e si vede. I sedili sono di pelle grigia, e c’è quello che sembra un mini-bar.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Lei può usufruire di tutto ciò che vuole, signora. C’è un pulsante per l’interfono che si collega all’abitacolo. O, se preferisce, può abbassare il finestrino che c’è tra noi”. Barnaby indica i vari pulsanti e io annuisco. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Prima che abbia la possibilità di chiudere la portiera, gli afferro un braccio. “Pensi che Holden Longworth sia una brava persona?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Penso di sì, signora”. La risposta suona alquanto automatica, come se conoscesse già la risposta che ci si aspettava da lui. O forse Holden ci sta ascoltando. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Barnaby chiude la portiera, a io mi siedo dietro il mini-bar. Ci sono dentro, adesso. Qualunque cosa accada stanotte, dubito di poterne avere il controllo. Spero soltanto che tutto vada bene – che Holden sia stato sincero e che  voglia soltanto cenare con me.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Mentre guidiamo verso la nostra destinazione, do un’occhiata al mini-bar. Ci sono due contenitori con del ghiaccio dentro. Uno ha una bottiglia di champagne, l’altro una di acqua con un piccolo assortimento di bottigliette di soda. Brevemente, penso di aprire lo champagne. So che è stato pensato per me, ma non mi fido del fatto che non sia avvelenato, anche se c’è ancora la chiusura di sicurezza. Tanto per cazzeggiare un po’, prendo la bottiglia e ne esamino la chiusura per controllarne i marchi. Non c’è segno che sia stata toccata, ma ancora non mi fido. Prendo invece la bottiglia dell’acqua, ma anche di questa non sono poi così sicura. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“C’è speranza che non muoia stanotte”. Guardo il mio riflesso in uno dei finestrini.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Cerco di rilassarmi più che posso, ma è difficile quando c’è così tanto che si agita nella mia mente. Per gran parte del viaggio, mi ritrovo a muovermi di continuo o a guardare fuori dai finestrini. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Grazie al cielo si tratta di un viaggio breve. Dopo soli quindici minuti, la limousine si ferma.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Sbircio fuori dal finestrino aspettandomi di essere soffiata via, ma ciò che vedo è molto diverso da ciò che sono solita chiamare villa. Di sicuro, la casa è enorme con la sua mastodontica facciata a due piani e un balcone che si allunga per tutto il secondo livello. È molto più grande di qualsiasi cosa che io abbia mai sognato di potermi permettere, ma di sicuro non è una villa. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Eccoci, Miss”. Barnaby mi apre la portiera, e io esco. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Afferro la mia borsetta e la bottiglia d’acqua mentre lui mi accompagna al vialetto d’ingresso e suona alla porta. Solo adesso che siamo qui in piedi mi ricordo che era previsto mi facessi accompagnare da Barnaby a prendere qualcosa da mangiare. Mi maledico in silenzio. Ora dovrò morire di fame.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("La porta si apre, e Holden mi sorride per salutarmi mentre si asciuga le mani in uno straccio per i piatti. “È stato veloce”.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Ho deciso che non ero affamata, dopotutto”. Cerco di far sembrare che abbia rifiutato di proposito la sua generosità e non che me ne sia semplicemente dimenticata. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“È tutto per ora, signore?”. Barnaby è fermo dietro di me con le mani nascoste dietro la schiena.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Certo. Tieni il telefono a portata di mano”. Holden lo saluta per un momento prima di tornare a rivolgere la sua attenzione a me. “Vieni dentro”.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Muovo un passo all’interno e mi guardo intorno, sentendomi vulnerabile ora che io e Holden siamo soli. L’arredamento di questa casa è semplice, con mobili di stile contemporaneo, muri beige e pavimenti in legno. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Fa’ come se fossi a casa tua”. Holden chiude la porta dietro di noi e procede verso la cucina. Lo seguo, guardandogli il culo. È vestito con un paio di pantaloni cachi e una polo a strisce bianche e blu. Di sicuro molto più casual di me. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Non ho ricevuto l’appunto in cui mi si informava del fatto che dovessimo essere così “rilassati”. Cerco di non sembrare arrabbiata perché io sembro una bambolina e lui è vestito come tutti i giorni. Ancora una volta, niente di questa notte è come me l’aspettavo, dunque perché essere sorpresi. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“È perché non ne ho mandato uno. È di questo tipo di sorprese che parlavo”. Mi guarda brevemente di rimando, tirando su col naso. “Siediti”. Spinge una sedia verso di me, di fronte alla penisola della sua cucina. Mi ci accovaccio e lo guardo doppiare la penisola per continuare a preparare la cena. La tensione nella stanza si può tagliare con un coltello. Essere qui è così strano – non suona giusto.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Allooooora, che cosa stai cucinando?”. Mi sporgo sulla penisola, per mostrargli quanto sia davvero interessata. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Dovrebbe essere merluzzo in crosta dukkah con couscous di barbabietole”.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Che cosa intendi per "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("dovrebbe essere")]), _vm._v("?”. Inarco un sopracciglio. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Proprio questo. Che "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("dovrebbe essere")]), _vm._v("”. Mi sorride da sopra una spalla e io annuisco lentamente.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Oh, giusto, perché tu non cucini. Eppure pensi sia d’obbligo criticare la mia cucina quando preparo per tua madre”.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Tu vieni pagata per cucinare. Io no”, il suo tono è secco.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Scivolo alle sue spalle mentre lui impiatta il cibo. Forse dovrei sperare che mi avveleni così che io non debba passare tutta la notte ascoltando le sue cazzate accondiscendenti. Questo non è decisamente un buon inizio. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Sei pronta?”. Si gira verso di me con due piatti nelle mani.  ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Guardo il cibo. Effettivamente non sembra così male. “Ti ho detto che non mangerò”.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Come vuoi”. Scrolla le spalle e porta i piatti nella sala da pranzo. Ancora una volta, sono costretta a seguirlo. Inizio a sentirmi come un cane che gli trotterella intorno ai piedi. Seccante.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Il suo tavolo da pranzo è da sei posti. Lui sceglie i posti centrali per noi due, sistemando entrambi i piatti prima che io abbia spostato la mia sedia. Lo ringrazio, anche se il mio trasporto è forzato. Tutto sembra forzato, ora come ora. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Hai spesso ospiti?” chiedo mentre lui fa il giro del tavolo.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Se anche la cena è casual, l’ambiente non lo è. Ci sono delle candele sul tavolo tra noi che provvedono a illuminare tutta la stanza. Sembra quasi che sia tutto organizzato per una serata romantica, non per una conversazione casual tra due nemici. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Vuoi un po’ di vino?”. Ignora completamente la mia domanda.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“No. Sto bene con la mia acqua”. Spingo verso di lui la mia bottiglia mezza piena. Se non ha una chiusura di sicurezza, non lo toccherò. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Bene”. Fa un respiro profondo, poi scompare dalla stanza, probabilmente per recuperare il vino. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Fisso il merluzzo sul suo letto di poltiglia rosa. Un sorrisetto mi attraversa le labbra al pensiero di come tutto sia stato pensato in modo perfetto. Si è impegnato molto per questo. Se non avessi visto le pentole sul fuoco, avrei pensato che avesse ordinato il cibo da un ristorante. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Holden fa ritorno con un secchiello e una bottiglia. Si versa un bicchiere di vino prima di sedersi e stendere il tovagliolo sulle sue gambe. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Allora, hai spesso ospiti?” chiedo di nuovo, cercando disperatamente di avviare una conversazione.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“No”. Solleva la forchetta e attacca il pesce. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Il silenzio ci passa sopra come un’onda. L’unico suono che è possibile sentire è il ticchettare della forchetta di Holden contro il piatto, seguito da quello della sua masticazione. Sprofondo nella sedia, a disagio, mentre la mia pazienza per questa situazione si va riducendo in fretta. Anche se sono felice che le sue intenzioni sembrino essere esattamente ciò che lui aveva detto che fossero, mi sento come se stessi perdendo tempo. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Holden”. Giocherello con le dita, non voglio guardarlo. “Perché sono qui?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Si ferma per asciugarsi la bocca con il tovagliolo. “Te l’ho detto. Vorrei che ci conoscessimo meglio”.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Questo prevede che parliamo. Tu non stai veramente parlando”. Disegno in aria un movimento circolare con la mano. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Di che cosa vuoi parlare?”. Prende un piccolo sorso di vino.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Non lo so. Pensavo che tu avessi qualcosa da dire”. Mi guardo intorno nella stanza, cercando disperatamente un appiglio. “È una bella casa, ma non è maestosa come sarebbe potuta essere”.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Dà indietro col capo, di scatto. “Pensavo che avessimo finito di insultarci a vicenda”.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Davvero? Non lo so”.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Tutto questo non deve essere strano, Piper”. Scuote la testa verso di me. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Certo che lo è. Tu mi hai rapita. Ti ho detto che volevo ucciderti. Non siamo amici. Questa cena è stata un’idea orribile”. Butto fuori, stanca delle cazzate. Non c’è ragione di tentare di salvare qualcosa con lui.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“No. Non siamo amici. Ma abbiamo un legame in comune. Mia madre”. Riprende la sua forchetta e continua a mangiare.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Questo non significa che dobbiamo torturarci imponendoci ognuno la presenza dell’altro quando non è necessario”. Mi pizzico il naso in un gesto di frustrazione. Quasi nello stesso momento, il mio stomaco brontola in modo abbastanza forte da svegliare i morti.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Sei affamata”. Lui libera una breve risata. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“No, non lo sono” insisto.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Sì, lo sei. Prova almeno il pesce. In effetti è piuttosto buono”. Mi indica il mio piatto con la sua forchetta.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Non sono interessata”. Alzo gli occhi al cielo.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Non ti piace il pesce?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Mi piace il pesce”.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Dunque sei interessata”. Si allunga sulla tavola per afferrare il mio piatto.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Che cosa stai facendo?” mi tiro leggermente indietro, una reazione istintiva. Perché il mio subconscio pensi che lui possa tirare il piatto contro di me, non ne ho idea. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Voglio assaggiarne un po’ per dimostrarti che non è avvelenato. È questo che ti preoccupa, vero?”. Cattura il mio sguardo, e io silenziosamente gli do la mia risposta. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Sogghigna prima di prendere un pezzettino dall’angolo del mio merluzzo e masticarlo rumorosamente.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Mmm, delizioso. Ecco. Vedi? Non avvelenato”. Rimette il piatto davanti a me. Poiché indugio nel prendere la forchetta, lui continua. “Ascolta, Piper. Non lascerò che Barnaby ti riporti a casa finché non avrai finito di mangiare. Ho preparato anche il dessert. Ora, so che sei affamata, quindi potresti smettere di essere cocciuta e mangiare. Non è un peccato ammettere che la mia cucina è migliore della tua”.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Stronzo!” gli urlo contro prima di realizzare che mi sta prendendo in giro. Allora mi ammorbidisco.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“C’è qualcosa sulla quale possiamo andare d’accordo”. Continua a mangiare.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Il cibo sembra buono, e più a lungo lo guardo, più il mio stomaco si contrae. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“That's something we can both agree on.” He continues eating. Non mangio niente dalla colazione. Volevo lasciare spazio per lo stravagante pasto da ristorante che mi era stato promesso. Invece, ho avuto questo.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Riluttante, prendo la forchetta. Holden inarca un sopracciglio mentre io spilucchio il pesce, frammentanolo ed esaminandolo. Prendo una cucchiaiata di couscous e l’annuso. La barbabietola libera un odore dolce. Allungo la lingua per assaggiarla, quindi mi fermo per decidere se mi piace o no prima di prenderne un boccone pieno. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Holden mi sorride attraverso il tavolo. “Vedi? Non era poi così difficile, no?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Sta’ zitto”, mugugno con la bocca piena di cibo. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Purtroppo, la sua cucina è di molto superiore alla mia. È particolarmente triste perché in apparenza lui non cucina mai, e io cucino spesso. Forse la cucina è un talento naturale che io semplicemente non possiedo.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Voglio scusarmi ancora”. Holden rivolge la sua attenzione al cibo mentre parla con me. “Non ho mai voluto essere così iperprotettivo con mia madre, ma davvero non posso farne a meno. Lei è tutto ciò che mi è rimasto, e sento che è un mio dovere di figlio assicurarmi che stia al meglio. È sempre stata una mamma meravigliosa. Voglio semplicemente che lei abbia tutte le cose belle che merita in questa vita”.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“La fai sembrare come se io non sia una cosa bella”. Mi irrito un po’.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Non è quello che intendevo”. Scuote il capo. “Prima non ti conoscevo. Voglio dire, ancora non ti conosco davvero. Tutto ciò che ho è ciò che mia madre mi ha detto. Sarebbe dovuto essere abbastanza. Lei ha sempre cantato le tue lodi. Ma io non sono solito fare le cose in un certo modo. Devono andare come dico io, presumo. Le persone di servizio dovrebbero essere qualificate e preventivamente cercate, prima di assumerle”.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Persone di servizio, eh?” lo interrompo. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Mi guarda, e la sua espressione è di scusa. “Continuo a fregarmi con le mie stesse parole, vero?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Mmm. Sembri avere un talento, in questo”. Aggredisco il mio cibo con più forza, quasi fosse la sua faccia.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Piper, mi dispiace. Io davvero non...” sospira. “Non so”.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Non sai come comunicare con le persone” lo aiuto. “Non sai come essere un essere umano decente. Non sai come non umiliare i tuoi ospiti”.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Può bastare”. Solleva le sue mani per fermarmi, e io indietreggio leggermente. “Sto facendo il meglio che posso. Davvero. Sto tentando disperatamente di compiacerti”.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Se stessi tentando disperatamente di piacermi, allora dovresti trattarmi come una tua pari. Questo” e indico tutto ciò che ci circonda. Il nostro cibo stravagante. Le candele kitsch sulla tavola. “Io non so che cos’è. Se volevi parlarmi, non dovevi fare questo. Potevamo semplicemente parlare”.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Tu meriti più di una semplice chiacchierata”. Mi lancia uno sguardo sincero. “Sono stato... così orribile con te. Tu non hai mai meritato niente di tutto ciò. Solo che io ero...”. Volta il viso lontano da me, e io ci vedo del rimorso. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Stavi semplicemente valutando le cose per tua madre. Ho capito”. Sospiro dentro di me, maledicendomi perché mi sento male per lui. “Non sei l’unico che ha perso qualcuno, Holden”.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Tua madre”. Annuisce, e sembra solenne. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Sì. Mia madre. E mio padre. Mio padre è morto quando avevo undici anni. Cancro alla prostata. È stato veramente orribile. Posso ancora sentirlo piangere”. Il dolore mi aggredisce il cuore mentre ne parlo. Il ricordo è ancora così limpido, come se solo ieri fossi rimasta ferma accanto alla porta della camera da letto dei miei genitori ad ascoltarlo piangere. La famiglia lo circondava, accudendolo, e non appena mia madre si voltò e mi vide, io subito scappai.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Mi dispiace sentire questo. Il cancro è orribile. Vorrei che avessero già trovato una cura. Una vera cura. Una che funzioni nel novantanove percento dei casi e che non è una roba piena di merda come sono spesso la chemio e le radiazioni e la chirurgia”.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Annuisco, d’accordo con lui.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Com’è stato perdere tua madre?”. Non mi guarda mentre mi pone la domanda. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Orribile. Benché non fossimo affiatate come siete tu e tua madre. Vorrei che lo fossimo state”. Abbasso lo sguardo, tentando di ricacciare indietro il senso di colpa che sento per non esserle stata abbastanza vicina prima che morisse.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Forse è stato meglio così. Forse non è stato terribile come sarà per me”.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Non penso che sia mai facile perdere un genitore”. Scuoto il capo. “E le nostre situazioni sono diverse. Dopo aver perso tua madre, tu andrai avanti con la tua vita una volta superato il dolore. Io sono rimasta incastrata con i miei due fratellastri”.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Quindi è per questo che non vi assomigliate affatto” sorride.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Fratelli di un’altra madre. Letteralmente”.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Non hanno un’altra famiglia che li possa crescere?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“No. Hanno solo me”. C’è qualcosa di pesante nel mio cuore mentre lo dico. Questo è uno di quei momenti in cui mi sento così sola.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Sono fortunati ad averti. Sembri una persona molto devota alla causa”. Il complimento sembra stranamente naturale, per venire da lui. Per niente forzato.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Mi hai... Mi hai appena detto qualcosa di carino?” fingo un sussulto. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Non farci l’abitudine”. Libera una breve risata, facendo un movimento circolare nell’aria con la sua forchetta come se volesse abbandonare l’argomento.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Non me lo sognerei nemmeno”. Mi porto la mano al petto. “Perché tutti noi sappiamo che Holden Longworth esploderebbe se fosse carino troppo a lungo”.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Ah ah. Molto divertente”, il sarcasmo nel suo tono è sottile, ma non potrei dire che non sia arrabbiato. “Comunque, davvero, ti è stato affidato qualcosa di pesante e lo stai gestendo bene. È qualcosa di cui essere orgogliosi”.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Sono orgogliosa di me stessa”, dico, pensosa. “Sinceramente all’inizio non pensavo che ce l’avrei fatta. Ho lasciato casa non appena ho potuto. Non potevo sopportare il mio patrigno o i ragazzi. Quindi ho fatto del mio meglio per non restare in contatto con loro. Non me ne sarebbe fregato niente se fossero vissuti o fossero morti. Eppure, in qualche modo, eccomi adesso. Badante. Genitore, persino. Se non altro, sembra che io sia un genitore. Non pensavo che sarebbe andata così, l’avere figli, per me”.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Ma vorresti avere figli, un giorno?”. Mi guarda.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("La domanda mi fa irrigidire anche se non saprei dire perché. “No? Sì? In realtà non è stato un mio pensiero per molto tempo. Voglio dire, avere figli è la naturale prosecuzione delle cose. Ma, ora come ora, voglio semplicemente andare avanti con la mia vita, preoccupandomi di crescere prima di tutto i miei fratelli. E tu? Vuoi dei bambini?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Holden si asciuga le labbra con il tovagliolo prima di posarlo sulla tavola. Il suo piatto è completamente vuoto. Doveva essere molto affamato. “Non riesco a immaginarmi sposato. E non vorrei figli fuori dal legame coniugale”.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Gli incidenti accadono”, mi irrito leggermente.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Non a me”. Scuote il capo. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Gli incidenti capitano a tutti, Holden. Tu non sei Dio”. Gli lancio un’occhiata sarcastica.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Non credo in quella merda”.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("La mia bocca si spalanca per un momento prima che la risata esploda. “Entrambi sappiamo che ci sono un po’ di cazzate, qui”.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Poggia i gomiti sul tavolo e si stringe le mani, guardandomi al di sopra di loro. La sua espressione è cambiata. È divertita ma morbida e colma di qualcosa che non saprei definire. Non avrei mai pensato di considerarlo di nuovo attraente. Ma il modo in cui mi sta guardando...")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Cosa?” mi porto una ciocca di capelli dietro l’orecchio, sentendomi improvvisamente consapevole di me.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Hai una meravigliosa risata”.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Il calore mi risale le guance. Non dovrebbe avere la capacità di farmi arrossire, eppure eccoci qui. La mia faccia tradisce il mio astio per lui. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Grazie” rispondo, docile.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Continua a guardarmi per un attimo di troppo prima di tornare in sé, sistemare le posate sul piatto e lasciando il suo tavogliolo. “Hai finito?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Già. Penso di sì”. Lui fissa il mio piatto. Ho mangiato la maggior parte del mio cibo, malgrado la mia decisione iniziale di non farlo. Mi sento perfettamente bene, quindi immagino che dopotutto non mi abbia avvelenata. È un sollievo.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Porto questi in cucina”. Si avvicina per togliermi il piatto. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Vuoi che venga con te?” ribatto.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Quello che vuoi. Puoi seguirmi. Puoi stare qui”. Non sembra mostrare alcuna preferenza. Penso in fretta. La sala da pranzo è più vicina alla porta d’ingresso, e io davvero non voglio più parlare con lui. Quando mi ha detto che gli piaceva la mia risata, ho sentito un’ondata di calore sollevarsi tra di noi. Rimanere a distanza da lui sarebbe una cosa intelligente da fare.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Rimarrò qui” decido. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Bene. Vuoi il dessert? Ho preparato un tortino di fragole. Scusami, non è niente di speciale”. Inarca un sopracciglio come per scusarsi. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Sto bene. Completamente piena”. Ora che ho mangiato, voglio solamente andarmene. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Già, sono piuttosto pieno anch’io. Potremo mangiarlo dopo”. Porta via i piatti.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Dopo?”. La mia testa scatta leggermente indietro.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Già. Ho pensato che potremmo andare di sopra nella stanza dei giochi e passare un po’ di tempo”. Mi guarda come per dirmi che me lo sarei dovuto aspettare. Come se fossimo davvero amici.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Ehi. Ehi” sollevo le mani, i palmi rivolti verso di lui. “Ho accettato la cena. Nient’altro”.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Sposta il suo peso da un piede all’altro, inclinando la testa da un lato. “Oh, andiamo, Piper. Giocare a freccette con me non ti ucciderà. Non ci vorrà nemmeno troppo tempo”.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Devo essere a casa per mezzanotte”. Prendo il telefono dalla borsa per controllare l’orario.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Che cosa accade a mezzanotte? Ti trasformi in una zucca?” mi prende in giro.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“No. Mio fratello chiama la polizia per cercarmi”, gli dico, tranquilla.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Wow. Proprio non puoi fidarti di me, eh?”. Il tono di offesa è forte nella sua voce.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Non mi hai dato niente su cui lavorare in questo senso”. Forzo un sorriso finto.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Ci sto provando” sospira, facendomi sentire in colpa.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Lo so”.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Beh, non siamo ancora vicini alla mezzanotte. Ce l’hai un po’ di tempo per un gioco”. Si volta per portare i piatti in cucina.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“No”. Rimetto il telefono nella borsa, difendendo la mia posizione.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Un gioco veloce”. Mi ignora ed esce dalla stanza.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Quale parte del "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("no")]), _vm._v(" non hai capito?” gli grido dietro.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“La parte del "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("no")]), _vm._v("”.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Il modo in cui lui ne parla con tanta nonchalance mi fa sorridere. In verità, anche se so che è una cattiva idea, una parte irrazionale di me vuole passare un po’ più di tempo con lui. Lui si è aperto un po’ con me, e stiamo iniziando a funzionare. Forse se passassimo un po’ più di tempo insieme, vederlo intorno a sua madre non sembrerebbe così strano. Questa non può che essere una cosa positiva, no?")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Aspetto finché non ritorna e a quel punto lo seguo disopra nell’enorme stanza dei giochi del piano più alto. Ci sono tavolo da biliardo, biliardino, hockey da tavolo, bocce, basket elettronico e alcune macchine da flipper di vecchia generazione. Se non fosse per l’angolo bar contro la parete più lontana, penserei che la stanza sia stata progettata per dei bambini. Sembra più una sala giochi che qualcosa che potresti trovare in una casa. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Carina”. Cerco di nascondere il mio ghigno mentre entro nella stanza.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Non mi piace annoiarmi”. Fa spallucce.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Non è per questo che c’è il Club Fet?”. Mi avvicino al tavolo da biliardo mentre lui prende due set di freccette dalle loro custodie sistemate accanto al bersaglio. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Resto a casa, di tanto in tanto”. Cammina verso di me e mi porge un set di freccette con le alette nere. I suoi polpastrelli sfiorano i miei mentre le posa sul mio palmo, e anche se so che non è stato intenzionale, il clima diventa improvvisamente intimo. Un brivido caldo mi scivola lungo la schiena, e quando lo guardo e i nostri occhi si incontrano, qualcosa mi arriva direttamente nel profondo, causandomi una piccola contrazione tra le gambe. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Desiderio.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Odio provarlo per lui. Odio essere qui in questa casa. Odio lui. Non lo voglio più intorno, ma mi sono intrappolata da sola accettando di venire qui.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("È solo un gioco, Piper. Prendilo in giro e poi vai via. Preferiresti tagliargli il cazzo che sentirlo dentro di te. Ricordatelo. Ricorda quello che ti ha fatto.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Ma tutto ciò a cui potevo pensare era quella notte che avevamo condiviso nel mio letto. Quando lo vedo comportarsi in modo così naturale e non minaccioso, non riesco più a vedere il mostro. Vedo l’uomo ferito che protegge ciò che ama di più al mondo – a ogni costo. E anche se io fossi il costo, potrei in qualche modo passarci sopra. Che cosa diavolo ho che non va? Ho bisogno di essere scopata. Ecco che cos’è questa sensazione, stabilisco. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Mi pizzico le guance e lascio andare un lungo sospiro, cercando di tornare in me. Forse, se non lo guardo, sarà più facile. Se riuscirò a passare indenne un’altra ora con lui, tutto andrà bene.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Holden si sistema sulla linea e tira le sue freccette. Ovviamente, il suo lancio è impeccabile. Becca due centri pieni e un triplo-venti. Dovrò farmi il culo.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Esibizionista” borbotto prima che venga il mio turno. Non colpisco nemmeno il bersaglio con le mie prime due freccette e la terza atterra nell’area nera fuori dal cerchio. “Un grande, grosso zero” annuncio trionfante.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Vuoi qualche puntatore?” tira sul col naso, sembrando contemporaneamente adorabile e delizioso. ‘Fanculo. Non posso guardarlo.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“No. Sono a posto”. Dico, incrociando le braccia al petto mentre aspetto che vada.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Come previsto, mi fa fuori. Il gioco finisce in meno di dieci minuti.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Beh, è stato divertente” mento, cercando di riprendere le mie freccette. Lui le guarda come se non sapesse che cosa sono.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Questo era solo un gioco di riscaldamento. Il 301 lo è sempre. Ora, giocheremo a cricket”.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Mugugno piuttosto forte. “Ma faccio schifo. Non voglio più giocare”.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Allora vuoi giocare a qualcos’altro? Ho molta scelta”. Gesticola indicando la stanza tutt’intorno. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Ti ho detto che devo andare a casa”. La mia espressione è severa.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Holden controlla l’ora sul suo orologio da polso. “Ancora non siamo vicini alla mezzanotte”.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Ho davvero bisogno di andare a casa”.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Non ha senso”. Mi gira intorno per andare all’angolo bar. “Vuoi qualcosa da bere?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Holden”. Pronuncio il suo nome come se volessi strangolarlo.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Sì”. Mi guarda da sopra la spalla, sorridendo dolcemente, e io mi sciolgo. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Che cos’ha che mi rende così difficile resistergli? Non si tratta dell’essere carino; si comporta come un marmocchio viziato. È un marmocchio viziato. E se continuo a dargliela vinta...")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Un altro gioco e me ne vado” rimango ferma come una statua, immobile.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Lui continua i fatti suoi, preparandosi un drink dietro il mobile bar. Fa roteare il bicchiere come un professionista, e io alzo gli occhi al cielo. Sta veramente cercando di impressionarmi? Mi rifiuto di farlo funzionare.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Sei molto più ridicolo di quanto pensassi”. Batto il tacco sul pavimento, stanca di aspettarlo.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Lui non risponde benché la sua espressione allegra si stia affievolendo in una impassibile. Finisce di preparare il suo drink e prende un lungo sorso prima di tornare da me e guardare la stanza. “Hai deciso a cosa vuoi giocare?”.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Pinball”. Veloce e semplice.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Bene. Scegli il tuo veleno”. Annuisce verso le macchine.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Scelgo la più vicina ed elaboro un gioco veloce. Allora Holden inizia il suo turno, battendo facilmente il mio punteggio. Cerco di non sentirmi frustrata al riguardo. Gioca a questi giochi tutto il tempo. Io no. È naturale che riesca meglio di me.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Bene, devo andare”. Lo saluto mentre vado verso le scale.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Fai una partita a biliardo con me”. Mi ignora di nuovo, dirigendosi verso la direzione opposta per prendere una stecca dallo scaffale sul muro.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Me ne sto andando” sbuffo. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Un gioco. E ti prometto che puoi andare”. Spinge una stecca fuori dallo scaffale e ne ingessa la punta.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Avevi detto che potevo andare dopo le freccette”. Inarco un sopracciglio verso di lui. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Non ti diverti con me?”. Mi guarda come se la risposta importasse davvero, e mi sento male benché non capisca perché. Di sicuro non può essere così solo.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Distolgo lo sguardo da lui, riflettendo.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Quando sarebbe diventato abbastanza? Non sembrava giusto, specialmente se stava tentando di toccare il mio lato buono.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Non ti rendi piacevole ai miei occhi forzandomi a stare qui”.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Chi ha detto che voglio piacerti?”. Dà uno scatto indietro con la testa.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“E allora perché vuoi che rimanga?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Avvolge entrambe le mani intorno alla sua stecca da biliardo e bilancia il peso con quella. “Perché pensavo che sarebbe stato divertente”.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Voglio dirgli che io non mi sto divertendo. Tuttavia sarebbe da maleducati, e non voglio litigare con lui. È importante che mi ricordi che sono nella sua tana – che non sono al sicuro qui.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Ancora un gioco”, capitolo con un sospiro. “Ma devi promettermi che dopo mi lascerai andare a casa”. Lo indico con un dito in segno di avvertimento.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Giuro sulla mia vita, che possa morire”. Incrocia indice e medio all’altezza del cuore.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Anch’io spero che tu possa morire, penso amaramente.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Non so come giocare” gli dico mentre giro intorno al biliardo per prendere una stecca dalla parete, tenendo il broncio e battendo il piede tutto il tempo. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Non ci vuole una laurea. Usi la stecca per spingere la palla bianca verso le altre palle. All’inizio, qualunque di loro è un bersaglio facile. Una volta che uno dei due va in buca, prendi o le palle a tinta unita o quelle a strisce. Se io mando in buca una a strisce, devo colpire quelle a strisce per tutto il resto della partita e tu puoi solo mandare in buca quelle a tinta unita. La palla numero otto rimane per ultima” spiega.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Okay. Ho capito. Facciamolo” gesticolo, annoiata.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Hai caldo?” chiede.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“No”. Cerco di imitare il modo in cui reggeva la stecca, allargando le gambe quanto permette il mio vestito per abbassarmi e arrivare con l’occhio al livello della palla bianca.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Dalla mia visuale periferica, vedo Holden che inizia a togliersi la camicia. Ciò mi fa perdere immediatamente la concentrazione.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Che cosa stai facendo?”. Mi rimetto diritta, praticamente dimenticandomi del gioco.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Che cosa ti sembra che stia facendo?”. Mi guarda per una frazione di secondo prima di appallottolare la camicia e lanciarla su una sedia vicina.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Non ne ho idea”, scuoto il capo.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Fa caldo, Piper. Io ho caldo. Tu no. Mi sto togliendo la camicia per stare più comodo”. Mi guarda come se la risposta fosse ovvia.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Sei strano”, borbotto, tornando a rivolgere la mia attenzione al gioco. O provandoci, almeno. Tutti quegli appetitosi muscoli... Lo odio. Lo odio. Lo odio.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Che cosa c’è di strano nel voler essere comodo?”. Riprende ad appoggiarsi di nuovo alla stecca da biliardo.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Lascia perdere. Dimentica che abbia detto niente”. Scuoto il capo prima di fare un tiro. La palla non va assolutamente vicino a dove avevo previsto che andasse. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Dovresti imparare a rilassarti”.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Guardo i muscoli delle sue braccia e dell’addome e poi indietro mentre lui li stira per iniziare il suo turno. È meraviglioso, e per questo lo odio ancora di più.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Manda dentro una palla dopo l’altra. Dovrei ringraziare del fatto che il gioco stia procedendo così in fretta. Non ci vorrà molto prima che sia finito.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Ne sono contenta, per lo più. Mentre da un lato so che sta facendo uno sforzo per sistemare le cose tra noi, dall’altro lui più che altro mi sta facendo incazzare. Il suo bel visino e il corpo sexy non dovrebbero essere per me una ragione per ronzargli intorno. Tuttavia posso sentire certi desideri risalire dentro di me quando lo guardo. Posso immaginare un miglior modo di utilizzo per la tavola da biliardo. C’è un gioco diverso con mazze e buchi che vorrei giocare. Ma non con lui. Mai con lui. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Ho indossato questo vestito per sedurlo. Uno stretto, nero, con gli spacchi ai lati. Volevo che vedesse ciò che non avrebbe mai più avuto. E tuttavia qui è lui che mi sta seducendo, sembrando disinteressato al mio vestito. La cosa divertente è che non ci sta nemmeno provando. Forse non deve farlo. Anche se è un coglione, è il suo aspetto da dominatore che mi attrae. Il modo in cui non deve nemmeno provarci. Sapendo che cosa può fare con quel corpo. Mi passo la lingua sul labbro inferiore, guardandolo come un predatore. Posso immaginarci sulla tavola da biliardo. Immaginare le mie gambe aggrappate alle sue anche mentre affonda dentro di me. Le mie mani ancorate alle sue spalle. Le mie unghie che affondano nella sua pelle meravigliosa. Graffiandolo. O meglio, lasciandogli cicatrici. Mi fermerebbe se lo facessi sanguinare? Ne dubito. Probabilmente mi scoperebbe ancora più forte. Il pensiero mi fa stringere le cosce. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Piper, è il tuo turno”.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Mmm?”. La mia testa fa uno scatto e la fantasia si dissolve. Lui è in piedi all’altro capo del tavolo e mi lancia uno sguardo strano. “Oh, già. Il mio turno”.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Do un’occhiata al tavolo. Gli restano solo due palle, inclusa la numero otto. Tutte le mie sono ancora in posizione. Sospiro dentro di me mentre inizio il mio turno.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Non quella”. Holden scuote il capo. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Cosa?” alzo lo sguardo su di lui.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Quell’altra”. Ne indica una a strisce che se ne sta buttata contro il binario di una delle buche all’angolo. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Non posso prendere quella” aggrotto le sopracciglia.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Sì, puoi. Semplicemente punta proprio lì”. Tocca con la punta del dito il binario accanto alla palla.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Eh, se lo dici tu” faccio spallucce, non volendo discutere con lui. Mi piego per prendere la mira, allineando la stecca nella direzione della palla.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“La tua postura è tutta sbagliata”.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Mi vuoi lasciar giocare o no?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Lascia che ti mostri come fare”. Fa il giro del tavolo prima che abbia avuto la possibilità di obiettare. “È così”. Prende la stecca dalle mie mani e si mette in posizione per il tiro.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Faccio del mio meglio per mandare a memoria la sua postura. Tuttavia è difficile quando tutto ciò che sembra in grado di fare è renderlo ancora più sexy. Vorrei che si fosse rimesso addosso quella dannata camicia. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Okay, penso di aver capito”. Espiro profondamente, riprendendo da lui la stecca.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Quando mi rimetto in posizione, lui ancora non sembra soddisfatto. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Quasi, ma non del tutto. Dev’essere più così”. Viene dietro di me, e la temperatura nella stanza sale improvvisamente intorno ai trenta gradi.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("La sua mano scivola lungo il mio braccio, causandogli un impulso elettrico. Il calore del suo corpo dietro di me sembra lanciare un attacco diretto a tutte le mie parti più sensibili. Il respiro mi si ferma in gola mentre lui avvicina il viso al mio, e tutta la concentrazione su ciò che stiamo facendo svanisce nel nulla.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Tieni su il gomito” mi dice, completamente ignaro di ciò che sto provando. Questa per lui è solo una lezione. Per me è qualcos’altro.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Gomito su”, ripeto debolmente, voltando lo sguardo al mio braccio dal momento che le mie articolazioni sembrano aver perso la loro funzionalità da quando lui ha posato l’altra sua mano sul gomito per essere sicuro che fosse alla corretta altezza.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Bene”, la sua voce si ammorbidisce, e quando rivolgo di nuovo lo sguardo a lui e i nostri occhi si incontrano, è come se tutto dentro di me diventasse liquido.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("La stanza è incredibilmente silenziosa, e c’è un muto tremolio che mi scorre sotto la pelle. O almeno, sembra che ci sia. Vengo riportata indietro alla prima notte in cui l’ho visto al Club Fet. Il modo in cui mi guardava. È così incredibilmente intenso. Potrei perdermi nei suoi occhi per sempre. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("La bocca diventa asciutta, ed è come se ogni altra parola che avrei potuto dire fosse evaporata. C’è un sottile cambiamento nella postura di Holden, e posso sentire che si sta avvicinando a me. Il movimento è così leggero che potrei averlo solo immaginato. Tutto ciò che so è che sembra ci sia meno spazio tra di noi. E anche se so che non dovrebbe essere così, mi piace.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Il buonsenso mi dice di respingerlo. Gli allarmi si sono spenti nella mia testa. Questo è pericoloso. Così fottutamente pericoloso. Se lui mi bacia, io sono finita. Gli strapperei via i vestiti e lo spingerei tra le mie cosce per dar vita alla mia fantasia da tavolo da biliardo. Ci vorrebbe un solo movimento. Tutto ciò che deve fare è piegarsi e baciarmi. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I secondi sembrano ore mentre rimaniamo immobili in posizione. Finalmente lui allontana lo sguardo dai miei occhi, e lo sposta sulle mie labbra. I suoi occhi sembrano quasi d’argento sotto le folte ciglia. Così sensuali. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Aspetto che si muova. Lo voglio. Sento che la follia mi ha sovrastata. Voglio che mi baci? Perché? È orribile. Lui è orribile, ma io sono eccitata. Comunque, questo non dovrebbe importare. Questa non è una cosa che chiunque potrebbe fare. Perché lui non è semplicemente chiunque, per me. Lui è il nemico. Ancora il mio nemico. Questo breve incontro non ha cambiato ciò. Noi ci odiamo a vicenda. No? O almeno, io lo odio. Non ho idea di cosa lui pensi di me. Cosa pensa di me? Non dovrebbe interessarmi.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Ma almeno baciami, dannazione. Fallo e basta. Chi se ne frega di chi siamo? Non voglio più pensarci. Ti voglio e basta. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Non posso più sostenere la tensione sessuale tra noi. Mi stringe così forte che qualcosa scatta dentro di me e io chiudo gli occhi per incoraggiarlo. Nello stesso, preciso istante, lui si allontana. Prima che le mie azioni diventino troppo ovvie, sono in grado di fermarmi. Dentro di me, spero che il mio movimento sia stato altrettanto discreto del suo avvicinarsi a me.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Si sta facendo tardi. Chiamo Barnaby per riportarti a casa”. Si allontana da me, e l’aria fredda riempie lo spazio in cui prima era il suo corpo. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Sono... turbata. Attonita. Confusa.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Probabilmente è una buona idea” mi faccio forza, incapace di guardarlo ancora.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("La situazione passa da sensuale a strana nel giro di un secondo. La nube di desiderio si dissolve, e io mi ritrovo a chiedermi che cosa diavolo stavo pensando. Almeno, lui ha avuto il buonsenso di fermarci. Ha salvato entrambi dalla catastrofe.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Holden prende la camicia e la indossa. I miei ormoni si spengono non appena lui si copre, ma il bisogno di un contatto sessuale non scompare del tutto. Sono semplicemente in grado di reindirizzarlo, adesso. So che lui non è l’unico che voglio. Ci sono cascata solo perché lui era così vicino, così accessibile.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Lui prende il telefono e chiama Barnaby. Quindi mi conduce al piano di sotto. Non passano nemmeno cinque minuti che la limousine è già fuori ad aspettarmi. Holden mi ringrazia per essere venuta. Io lo ringrazio per la cena. Siamo innaturalmente civili l’uno con l’altra, la conversazione è troppo normale per sembrare reale. A quel punto mi ritrovo in limousine e ringrazio il cielo che tutto sia finito. Sono sopravvissuta a una cena con Holden, e sto tornando a casa sana e salva. Sana e salva ma eccitata da morire. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Questo non va bene. Non se ne parla che io passi la notte senza aver avuto nessun tipo di sfogo sessuale. E non parlo di quel tipo di sfogo con le batterie.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Faccio appena in tempo a entrare in casa e a dimostrare a Earl che sono tutta intera e sono di nuovo fuori. Diretta al Club Fet. Stanotte non ci sarà esclusione di colpi. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "page-break-before": "always",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("CAPITOLO 2")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("HOLDEN")]), _vm._v(" "), _c('p', {
    staticClass: "section-break"
  }, [_vm._v("––––––––")]), _c('div', {
    staticClass: "decoration-scene-break"
  }, [_c('div', {
    staticClass: "decoration-scene-break-inner"
  }, [_c('img', {
    staticClass: "decoration-scene-break",
    attrs: {
      "alt": "image",
      "src": "d2d_images/scene_break.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first-in-scene",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('span', {
    staticClass: "first-scene-phrase"
  }, [_c('span', {
    staticClass: "first-in-scene character-c"
  }, [_vm._v("C")]), _vm._v("he cosa diavolo stavo")]), _vm._v(" pensando? Nessuno mi può trattare così. Nessuno.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Se qualcuno fosse passato in auto davanti alla casa di Piper e mi avesse visto inginocchiato sulla soglia, mi avrebbe riso dietro per il resto dei miei giorni. Inginocchiarsi di fronte a una sottomessa... Non ero mai arrivato così in basso.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Mi ci sono volute tutte le mie forze per ricordarmi che dovevo fare qualunque cosa per riaverla indietro. Era tutto ciò che mi passava per la testa mentre la rabbia mi montava dentro. In quel momento, non volevo nient’altro che abbassarle i pantaloni del pigiama, farla piegare sul mio ginocchio e sculacciarla finché non mi avesse fatto male la mano. Quindi l’avrei legata fino a farle dolere tutte le articolazioni. Quindi l’avrei scopata al punto che la fica le avrebbe fatto male per giorni. Questo era tutto ciò che volevo fare. Tuttavia, non è ciò che è successo. È anzi molto distante da ciò che è successo.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Stavo lì in ginocchio, tollerando la sua scenata – l’umiliazione e l’abuso fisico. Forse lei meritava quel pagamento dopo ciò che le avevo fatto. Ma non avevo nessun interesse nel chiederle di venire a cena con me. Nessuno. Nada. Non le dovevo quello. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Perché l’ho fatto, allora?")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Conosco la risposta, ma non voglio ammetterlo con me stesso. Non voglio nemmeno pensarci. Tutto ciò che volevo fare dopo che lei aveva accettato il mio invito era cucinare un pasto che sapevo l’avrebbe conquistata, imbastire una conversazione stimolante e mandarla via. Allora le cose sarebbero tornate alla normalità. Lei sarebbe potuta tornare a lavorare per mia madre, e noi saremmo stati civili l’uno con l’altra finché tutto non fosse finito. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Ma a quel punto abbiamo iniziato a parlare. Mi ha detto dei suoi genitori, e ho iniziato a sentire un legame con lei. So che lei ha vissuto molto di ciò che ho vissuto io. E posso affermare che è una brava persona. Una persona che torna a casa per prendersi cura dei suoi due fratellastri con cui non ha nemmeno un legame di sangue può essere una cattiva persona. E lei a mia madre piace così tanto. Forse questa è una larga parte della mia motivazione. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Ho scoperto di voler passare più tempo con lei – di volerla conoscere meglio. Tuttavia lei non voleva lo stesso. Non sono veramente sicuro di come dimostrarle che non sono del tutto un bastardo senza cuore. Sembriamo in grado di comunicare soltanto in quel modo. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Forse questo è ciò che vuole. Forse questo è il motivo per cui ha indossato quel vestito.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Nel momento in cui ha varcato la soglia, i miei occhi si sono incollati al suo corpo. Quel vestito lasciava ben poco all’immaginazione. Non nel senso che rivelava tutto, ma era così aderente che era praticamente una seconda pelle. Naturalmente, i suoi seni spuntavano dalla scollatura. Ciò mi ha reso difficile concentrarmi durante gran parte della cena. Tutto ciò a cui potevo pensare era a premere il mio viso contro la sua pelle soffice, ripercorrere le rotondità del suo petto con la lingua, abbassare il davanti del suo vestito per prendere un capezzolo tra le labbra e sentirlo indurirsi mentre lo succhiavo con fervore. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Il mio pene è rimasto dannatamente duro per tutta la cena. È stato seccante. Ma so che lei stava tentando o di sedurmi o di mettermi in imbarazzo. Nessuna donna normale avrebbe indossato un vestito come quello in un ristorante costoso. Ed era esattamente dove pensava che l’avrei portata quando le avevo chiesto di uscire insieme. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("O forse si era vestita per andare da qualche altra parte dal momento che aveva deciso inizialmente di cancellare l’appuntamento. Non c’è modo di capire. Tutto ciò che so è che quel vestito era da impazzire. Il modo in cui si incollava a ogni curva. Il fruscio del tessuto mentre camminava, come se potesse strapparsi ed esporre il suo corpo in tutta la sua gloriosa nudità. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Se ciò fosse magicamente accaduto, penso che avrei saltato la cena e sarei arrivato direttamente al dessert. Avrei divorato il liquido dolce tra le sue gambe. L’avrei fatta stendere sul piano della tavola e l’avrei rivendicata, scopandola finché le candele non fossero cadute e rotolate via, abbattendosi sul pavimento, lasciando la stanza in un buio, bollente disordine. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Il desiderio era lì. Non se n’è mai andato, ma in qualche modo ero stato in grado di calmarmi a sufficienza da ascoltare davvero quello che lei aveva da dire. E in quei momenti, l’ho vista più come una persona che come un oggetto, l’ho vista come qualcuno di vero e genuino e importante. E ho visto qualcuno che volevo conoscere.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Ecco perché, quando la cena è finita, ho pensato che sarebbe stato divertente farla restare per un po’. Anche se lei non voleva. Ha cambiato la mia opinione su di lei, ma non ho potuto cambiare la sua opinione su di me. Tuttavia ho voluto provare.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("La frustrazione è tutto ciò che ho ottenuto coi miei sforzi. Lei non si stava divertendo. Potevo vederlo, ma ancora volevo essere egoista.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Sapendo che i metodi convenzionali non stavano funzionando, ho deciso di giocare sporco. In verità, faceva caldo da morire nella stanza dei giochi. La parte superiore della casa è sempre più calda di quella inferiore. Ma sapevo anche di poter usare il mio corpo come una distrazione. Il fatto che lei fosse venuta a letto con me era in primo luogo la prova che mi trovava desiderabile.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Le mie buffonate avevano come unico scopo una conversazione brillante. Sapevo che non potevamo essere di nuovo così vicini. Per quanto la desidero, l’avrei scopata troppo forte, ed è un momento delicato – visto che cercavo di riportarla al lavoro da mia madre. Non posso complicare così tanto le cose. Possiamo fare questi giochetti di seduzione, e io posso fantasticare finché il mio cuore non è soddisfatto, ma non posso più andare a letto con lei. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Ciò è più facile a dirsi che a farsi quando lei appare... così. Viso perfetto. Corpo meraviglioso. Gambe lunghe delle miglia. Quando lei mette il broncio e batte i piedi, mi fa diventare matto. Quando fa qualunque cosa, mi fa diventare matto. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Ho pensato che insegnarle a tirare a biliardo avrebbe rotto il ghiaccio nella lunga serie di momenti imbarazzanti. Tuttavia avevo torto, di nuovo.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Volevo insegnarle come tirare, e lei ha premuto il suo corpo contro di me. È stato molto sottile, ma l’ho sentito. Ho sentito il calore che esalava da lei. Ha tremato leggermente tra le mie braccia, e ciò ha reso il mio pene improvvisamente molto attento – ha reso la mia testa, che inizialmente era al comando, in grado di cedere il passo a ciò che ho tra le gambe.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Quando l’avevo tra le mie braccia, ogni fibra del mio corpo voleva essere dentro di lei. L’ho avvolta. Coperta. Dominata. Tuttavia non era un questione di forza. Quei momenti erano così delicati. Come una porcellana in equilibrio precario sul bordo di un tavolo. Una mossa sbagliata e tutto sarebbe andato in pezzi intorno a me. La mia determinazione. In frantumi. E allora non ci sarebbe stato modo di tornare indietro. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Era un’opzione che non potevo permettermi. Tuttavia l’incantesimo era così forte! Nel momento in cui mi ha guardato, ho capito che anche lei lo voleva. Voleva essere baciata. Voleva essere scopata.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Sarebbe stato così semplice per me sollevarla e farla sedere sul tavolo da biliardo. Sollevare il suo vestito, far scivolare le dita sotto i bordi delle sue mutandine e strapparle via. Scommetto che la sua fica era già bagnata per me. Dio, avrei voluto sentirla. Avrei voluto assaggiarla.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Mi avrebbe fatto entrare. Saremmo diventati una cosa sola. E forse avrei trovato un po’ di pace, lì. Sentito lo stesso conforto di quella notte, quando andai a casa sua dopo aver scoperto che mia madre aveva il cancro. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Tuttavia non lo merito. Sono stato orribile con Piper. Non merito nessun tipo di pace. E lei sicuramente non dovrebbe essere colei che deve concedermela.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Non posso più ferirla. Non posso fare questa cosa che potrebbe potenzialmente farmi sentire più vicino a lei. E io non posso promettere a me stesso che non proverei qualcosa se dovessi portarla nel mio letto.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Non posso permettermi da far avvicinare qualcuno a me. Ho perso tutti coloro che mi circondavano. È la mia maledizione. ‘Fanculo tutti questi pensieri. Il sesso dovrebbe semplicemente essere sesso. È sempre stato solo sesso.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Con uno sforzo monumentale, in qualche modo sono stato in grado di mettere a tacere il mio pene e di riportare il cervello al comando. Sono stato in qualche modo in grado di non baciare Piper anche se lo volevo disperatamente. Sono stato in qualche modo in grado di fare una mossa cavalleresca e di essere un uomo di parola. Era solo una cena. Solo una cena.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Ma mentre lei attraversava la soglia e andava verso la limousine, ho provato uno strano senso di perdita. Questa sarebbe stata l’ultima volta che avremmo interagito così. Doveva essere per il bene di mia madre – per mantenere tutto sul piano professionale.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Ho chiuso la porta con un sospiro, la mente e il corpo che mi dolevano per il pensiero di aver perso un’opportunità. Quanto spesso il lupo lascia andare il coniglio via dalle sue grinfie senza alcuna ferita? Questo richiedeva più sforzo di quanto ne valesse la pena, ma almeno era finita, e ora le cose sarebbero tornate come dovevano essere.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Ho agito bene, mi sono detto. Ora è il momento della mia ricompensa. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Questa erezione non ha intenzione di andarsene.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Sono andato in bagno per masturbarmi, sentendomi perciò un pervertito. Tutto ciò a cui potevo pensare mentre lavoravo il mio pene era togliere il vestito con Piper e divertirmi con lei. È seccante il modo in cui occupa le mie fantasie, ma devo ricordarmi che è solo perché la memoria di lei è così fresca nella mia mente.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("L’orgasmo era deludente e sono rimasto insoddisfatto. Ho bisogno di qualcosa in più. Più di questo. Più della mia mano e di quattro pareti fredde intorno a me. Ho bisogno di essere con una donna che cancelli questi pensieri morbosi riguardo qualcuno che non posso avere. Ho bisogno di dominare e di riprendere il controllo. Ho bisogno di andare al Club Fet.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "page-break-before": "always",
      "text-align": "justify"
    }
  }, [_vm._v("Per sostenere ulteriormente questo autore, posta per favore una recensione dopo aver letto questo libro. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "x-large",
      "page-break-before": "always",
      "text-align": "justify"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "2",
      "src": "d2d_images/image001.png",
      "width": "2"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "section-break"
  }, [_vm._v("––––––––")]), _c('div', {
    staticClass: "decoration-scene-break"
  }, [_c('div', {
    staticClass: "decoration-scene-break-inner"
  }, [_c('img', {
    staticClass: "decoration-scene-break",
    attrs: {
      "alt": "image",
      "src": "d2d_images/scene_break.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first-in-scene",
    staticStyle: {
      "font-size": "large",
      "font-weight": "bold",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticClass: "first-scene-phrase"
  }, [_c('span', {
    staticClass: "first-in-scene character-l"
  }, [_vm._v("L")]), _vm._v("a tua recensione e")]), _vm._v(" i tuoi consigli fanno la differenza ")]), _vm._v(" "), _c('p', {
    staticClass: "section-break"
  }, [_vm._v("––––––––")]), _c('div', {
    staticClass: "decoration-scene-break"
  }, [_c('div', {
    staticClass: "decoration-scene-break-inner"
  }, [_c('img', {
    staticClass: "decoration-scene-break",
    attrs: {
      "alt": "image",
      "src": "d2d_images/scene_break.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first-in-scene",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('span', {
    staticClass: "first-scene-phrase"
  }, [_c('span', {
    staticClass: "first-in-scene character-l"
  }, [_vm._v("L")]), _vm._v("e recensioni e i consigli")]), _vm._v(" sono fondamentali per il successo di qualunque autore. Se ti è piaciuto questo libro scrivi una breve recensione, bastano davvero poche righe, e parla ai tuoi amici di ciò che hai letto. Aiuterai l'autore a creare nuove storie e permetterai ad altri di divertirsi come hai fatto tu.")]), _vm._v(" "), _c('p', {
    staticClass: "section-break"
  }, [_vm._v("––––––––")]), _c('div', {
    staticClass: "decoration-scene-break"
  }, [_c('div', {
    staticClass: "decoration-scene-break-inner"
  }, [_c('img', {
    staticClass: "decoration-scene-break",
    attrs: {
      "alt": "image",
      "src": "d2d_images/scene_break.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first-in-scene",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('span', {
    staticClass: "first-scene-phrase"
  }, [_c('span', {
    staticClass: "first-in-scene character-i"
  }, [_vm._v("I")]), _vm._v("l tuo sostegno è importante")]), _vm._v("!")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "x-large",
      "page-break-before": "always",
      "text-align": "justify"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "2",
      "src": "d2d_images/image001.png",
      "width": "2"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "section-break"
  }, [_vm._v("––––––––")]), _c('div', {
    staticClass: "decoration-scene-break"
  }, [_c('div', {
    staticClass: "decoration-scene-break-inner"
  }, [_c('img', {
    staticClass: "decoration-scene-break",
    attrs: {
      "alt": "image",
      "src": "d2d_images/scene_break.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first-in-scene",
    staticStyle: {
      "font-size": "large",
      "font-weight": "bold"
    }
  }, [_c('span', {
    staticClass: "first-scene-phrase"
  }, [_c('span', {
    staticClass: "first-in-scene character-s"
  }, [_vm._v("S")]), _vm._v("ei in cerca di un")]), _vm._v("'altra bella lettura?")]), _vm._v(" "), _c('p', {
    staticClass: "section-break"
  }, [_vm._v("––––––––")]), _c('div', {
    staticClass: "decoration-scene-break"
  }, [_c('div', {
    staticClass: "decoration-scene-break-inner"
  }, [_c('img', {
    staticClass: "decoration-scene-break",
    attrs: {
      "alt": "image",
      "src": "d2d_images/scene_break.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "x-large",
      "text-align": "justify"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "113",
      "src": "d2d_images/image000.png",
      "width": "113"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "section-break"
  }, [_vm._v("––––––––")]), _c('div', {
    staticClass: "decoration-scene-break"
  }, [_c('div', {
    staticClass: "decoration-scene-break-inner"
  }, [_c('img', {
    staticClass: "decoration-scene-break",
    attrs: {
      "alt": "image",
      "src": "d2d_images/scene_break.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first-in-scene",
    staticStyle: {
      "font-weight": "bold",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticClass: "first-scene-phrase"
  }, [_c('span', {
    staticClass: "first-in-scene character-i"
  }, [_vm._v("I")]), _vm._v(" tuoi libri, la tua")]), _vm._v(" lingua")]), _vm._v(" "), _c('p', {
    staticClass: "section-break"
  }, [_vm._v("––––––––")]), _c('div', {
    staticClass: "decoration-scene-break"
  }, [_c('div', {
    staticClass: "decoration-scene-break-inner"
  }, [_c('img', {
    staticClass: "decoration-scene-break",
    attrs: {
      "alt": "image",
      "src": "d2d_images/scene_break.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first-in-scene",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('span', {
    staticClass: "first-scene-phrase"
  }, [_c('span', {
    staticClass: "first-in-scene character-b"
  }, [_vm._v("B")]), _vm._v("abelcube Books aiuta")]), _vm._v(" i lettori a trovare nuovi libri da leggere. Giochiamo a trovare la tua anima gemella, facendoti incontrare il tuo prossimo libro.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Il nostro catalogo è composto da libri prodotti su Babelcube, un luogo di scambio che permette l'incontro tra autori e traduttori e distribuisce i loro libri in diverse lingue in tutto il mondo. I libri che troverai sono stati tradotti per permetterti di scovare bellissime letture proprio nella tua lingua.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Siamo orgogliosi di poterti offrire tutti i libri del mondo.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Se vuoi saperne di più sui nostri titoli esplora il catalogo e iscriviti alla nostra newsletter per conoscere tutte le prossime uscite, vieni a trovarci su:")]), _vm._v(" "), _c('p', {
    staticClass: "section-break"
  }, [_vm._v("––––––––")]), _c('div', {
    staticClass: "decoration-scene-break"
  }, [_c('div', {
    staticClass: "decoration-scene-break-inner"
  }, [_c('img', {
    staticClass: "decoration-scene-break",
    attrs: {
      "alt": "image",
      "src": "d2d_images/scene_break.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first-in-scene",
    staticStyle: {
      "text-align": "justify",
      "text-decoration": "underline"
    }
  }, [_c('a', {
    attrs: {
      "href": "http://www.babelcubebooks.com/",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "first-scene-phrase"
  }, [_c('span', {
    staticClass: "first-in-scene character-w"
  }, [_vm._v("w")]), _vm._v("ww.babelcubebooks")]), _vm._v(".com")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26b8d63c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/c003.vue
// module id = 66
// module chunks = 0